import repository from 'client/repository';
import { processCard } from '../domain';

export const getCardCheckerCard = state => {
    const { cards, location, supervisor, config } = state;

    const cardCheckerCardQrCode = repository.auth.getQRCode();
    const cardCheckerCard = cardCheckerCardQrCode ? cards.cards[cardCheckerCardQrCode] : null;

    return cardCheckerCard ? processCard(cardCheckerCard, location, supervisor, config) : null;
};

export const getCurrentCard = state => {
    const { cards, location, supervisor, config } = state;
    const { currentQrCode } = cards;

    const card = currentQrCode ? cards.cards[currentQrCode] : null;
    return card ? processCard(card, location, supervisor, config) : null;
};